module.exports = __webpack_public_path__ + "img/developer-3.810da66e.png";